import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { useIntl } from 'react-intl';
function getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
export function legacyInjectIntl(WrappedComponent, options = {}) {
    const { intlPropName = 'intl', forwardRef = false } = options;
    function WithIntl(props) {
        const intl = useIntl();
        const injectedProps = {
            [intlPropName]: intl,
        };
        return _jsx(WrappedComponent, Object.assign({}, props, injectedProps));
    }
    WithIntl.displayName = `legacyInjectIntl(${getDisplayName(WrappedComponent)})`;
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) {
        const ForwardRefComponent = React.forwardRef((props, ref) => _jsx(WithIntl, Object.assign({}, props, { ref: ref })));
        ForwardRefComponent.displayName = WithIntl.displayName;
        ForwardRefComponent.WrappedComponent = WrappedComponent;
        return hoistNonReactStatics(ForwardRefComponent, WrappedComponent);
    }
    return hoistNonReactStatics(WithIntl, WrappedComponent);
}
export default legacyInjectIntl;
